import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { environment } from 'src/environments/environment';
import { ExtensionService } from '../../services/extension.service';

// Visibility is decided by the layout's banner slot (system-layout bannerSlot$);
// this component only renders content and reports its dismissal.
@Component({
  selector: 'app-extension-block',
  templateUrl: './extension-block.component.html',
  styleUrls: ['./extension-block.component.scss'],
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtensionBlockComponent {
  private extension = inject(ExtensionService);

  extensionLink = environment.extensionLink;

  close(): void {
    this.extension.hideInfoTemporarily();
  }
}
